import { __assign } from "tslib";
var InvoiceItemBuilder = /** @class */ (function () {
    function InvoiceItemBuilder() {
        this.item = {
            id: '1',
            quantity: 1,
            name: 'INVOICE ITEM NAME',
            price: { amount: '30', currency: 'EUR' },
            total: { amount: '30', currency: 'EUR' },
            discount: undefined,
            fees: [],
        };
    }
    InvoiceItemBuilder.prototype.withId = function (id) {
        this.item.id = id;
        return this;
    };
    InvoiceItemBuilder.prototype.withQuantity = function (quantity) {
        this.item.quantity = quantity;
        return this;
    };
    InvoiceItemBuilder.prototype.withName = function (name) {
        this.item.name = name;
        return this;
    };
    InvoiceItemBuilder.prototype.withPrice = function (price) {
        this.item.price = price;
        return this;
    };
    InvoiceItemBuilder.prototype.withTotal = function (total) {
        this.item.total = total;
        return this;
    };
    InvoiceItemBuilder.prototype.withDiscount = function (discount) {
        this.item.discount = discount;
        return this;
    };
    InvoiceItemBuilder.prototype.withFee = function (fee) {
        this.item.fees.push(fee);
        return this;
    };
    InvoiceItemBuilder.prototype.build = function () {
        return __assign({}, this.item);
    };
    return InvoiceItemBuilder;
}());
export { InvoiceItemBuilder };
//# sourceMappingURL=invoice-item-builder.js.map